module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/logos/logo-aa-077cea675c94357243ad279f2d5f9763.svg";